export default __webpack_public_path__ + "static/media/stats.3af1ab28.svg";